<template>
  <v-container>
    <v-layout row>
      <v-flex xs12>
        <h1>Главная</h1>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {}
  },
  created () {
    this.$store.commit('setPageTitle', 'Главная')
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Home.vue